import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Caption, LayoutHorizontal, LayoutTile } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorCodeMessage = ({
  errorId
}) => /*#__PURE__*/_jsx(LayoutTile, {
  display: "inline-block",
  paddingBlock: "space-xxs",
  paddingInline: "space-sm",
  children: /*#__PURE__*/_jsx(Caption, {
    as: "div",
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
      as: "span",
      flexWrap: "wrap",
      gapColumn: "space-sm",
      gapRow: "space-3xs",
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "enrichmentProperties.panel.error.errorId"
        })
      }), errorId]
    })
  })
});